import { ArrowRight } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

import "./public-navbar.css";

const navLinks = [
  { to: "/", label: "Home", end: true },
  { to: "/menu", label: "Menu", activePaths: ["/cart"] },
  { to: "/about", label: "About" },
  { to: "/delivery", label: "Delivery" },
  { to: "/contact", label: "Contact" },
];

function isActive(pathname, link) {
  if (link.end) {
    return pathname === link.to;
  }

  return (
    pathname === link.to ||
    pathname.startsWith(`${link.to}/`) ||
    link.activePaths?.some((path) => pathname === path || pathname.startsWith(`${path}/`))
  );
}

export default function PublicNavbar() {
  const { pathname } = useLocation();

  return (
    <header className="sugalumps-site-header">
      <div className="sugalumps-site-header__inner">
        <Link to="/" className="sugalumps-brand">
          <span className="sugalumps-brand__mark">SL</span>

          <span className="sugalumps-brand__copy">
            <strong>SugaLumps</strong>
            <small>Cupcakery &amp; Sweet Treats</small>
          </span>
        </Link>

        <nav className="sugalumps-site-nav" aria-label="Primary navigation">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={isActive(pathname, link) ? "active" : undefined}
              aria-current={isActive(pathname, link) ? "page" : undefined}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <Link to="/menu" className="sugalumps-button sugalumps-button--header">
          Order Now
          <ArrowRight size={17} />
        </Link>
      </div>
    </header>
  );
}
